import { render, staticRenderFns } from "./CountrySwitcherModal.vue?vue&type=template&id=240c0acc"
import script from "./CountrySwitcherModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountrySwitcherModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CountrySwitcherModal.vue?vue&type=style&index=0&id=240c0acc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports